import axios from 'axios'
import _ from 'lodash'
import * as gtmHelper from '@/helpers/gtmHelper.js'

export default {
  namespaced: true,
  state: {
    totalPrice: 0,
    totalPriceVAT: 0,
    basePrice: undefined,
    basePricePerPiece: undefined,
    totalExtra: undefined,
    totalPostage: undefined,
    postagePricePerPiece: undefined,
    extras: undefined,
    serviceType: undefined,
    productDelivery: {
      format: {},
      page_count: {},
      addressLimit: {},
      productName: null,
      productId: null,
      salesOrganization: null
    },
    calculatePriceResponse: {},
    calculatePriceError: undefined,
    calculatePriceSuccess: false,
    isLoading: false
  },
  mutations: {
    // map calculate response to cart store
    UPDATE_PRICE: (state, response) => {
      state.calculatePriceResponse = response
      if (response.baseProduct && response.baseProduct.price) {
        state.basePrice = response.baseProduct.price / 100
        state.basePricePerPiece =
          response.baseProduct.price / response.baseProduct.count / 100
      }
      if (response.total && response.total) {
        state.totalPrice = response.total / 100
      }
      if (response.total && response.totalWithVAT) {
        state.totalPriceVAT = response.totalWithVAT / 100
      }
      if (response.postage && response.postage.length >= 1) {
        state.totalPostage = _.sumBy(response.postage, postage => {
          return postage.price / 100
        })
        state.postagePricePerPiece =
          state.totalPostage / response.baseProduct.count
      }
      if (
        response.additionalServices &&
        response.additionalServices.length >= 1
      ) {
        state.extras = response.additionalServices.map(service => {
          let extra = {}
          extra.name = service.name
          extra.price = service.price / 100
          extra.count = service.count
          extra.pricePerPiece = service.price / 100 / service.count
          extra.priceWithVat = service.priceWithVat / 100
          return extra
        })
      } else {
        state.extras = {}
      }
    },
    CALCULATE_SUCCESS: state => {
      state.calculatePriceSuccess = true
      state.calculatePriceError = undefined
    },
    CALCULATE_FAILURE: (state, error) => {
      state.calculatePriceError = error
    },
    SET_LOADING: (state, value) => {
      state.isLoading = value
    },
    UPDATE_PRODUCTDELIVERY: (state, payload) => {
      state.productDelivery = payload
    },
    UPDATE_SERVICETYPE: (state, payload) => {
      state.serviceType = payload
    }
  },
  actions: {
    CALCULATE_PRICE: ({ commit }, data) => {
      commit('SET_LOADING', true)
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_W2P_API_BASE_URL}/pricing/calculatePrice`,
        data
      })
        .then(response => {
          commit('CALCULATE_SUCCESS')
          commit('UPDATE_PRICE', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('CALCULATE_FAILURE', error)
          commit('SET_LOADING', false)
        })
    },
    PUSH_GTM_PURCHASE: ({ state }, data) => {
      const pricing = state.calculatePriceResponse

      const transactionInfo = {
        event: 'transaction',
        ecommerce: {
          currencyCode: pricing.ISO_units,
          purchase: {
            actionField: {
              id: data.transactionId,
              revenue: gtmHelper.toDecimalPrice(pricing.totalWithVAT),
              tax: gtmHelper.toDecimalPrice(pricing.VATAmount)
            },
            products: gtmHelper.getGtmProducts()
          }
        }
      }

      window.dataLayer.push(transactionInfo)
    }
  }
}
